(() => {
  if (customElements.get("pe-bf-rotating-offer")) return;
  const badges = new Set();
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  let clock;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { entry.target.inViewport = entry.isIntersecting; });
  });
  customElements.define("pe-bf-rotating-offer", class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const abort = new AbortController(), options = { signal: abort.signal };
      this.index = 0; this.paused = false; this.hovered = false; this.focused = false;
      this.button = this.querySelector("button");
      this.live = this.querySelector("[data-bf-offer-live]");
      this.static = this.querySelector("[data-bf-offer-static]");
      const card = this.closest(".product-card-wrapper");
      this.button.addEventListener("click", event => { event.stopPropagation(); this.paused = !this.paused; this.paint(); }, options);
      card.addEventListener("pointerenter", event => { if (event.pointerType === "mouse") { this.hovered = true; this.paint(); } }, options);
      card.addEventListener("pointerleave", () => { this.hovered = false; this.paint(); }, options);
      card.addEventListener("focusin", () => { this.focused = true; this.paint(); }, options);
      card.addEventListener("focusout", event => { this.focused = card.contains(event.relatedTarget); this.paint(); }, options);
      badges.add(this); observer.observe(this); this.paint();
      if (!clock) clock = setInterval(() => { if (!document.hidden) badges.forEach(b => b.cycle()); }, 3000);
      this.cleanup = () => {
        abort.abort(); observer.unobserve(this); clearTimeout(this.pending); badges.delete(this);
        if (!badges.size) { clearInterval(clock); clock = null; }
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    stopped() { return reduced.matches || this.paused || this.hovered || this.focused; }
    paint() {
      clearTimeout(this.pending); this.classList.remove("is-changing");
      const showBoth = reduced.matches;
      this.live.hidden = showBoth; this.static.hidden = !showBoth;
      this.live.textContent = this.index ? "ADD 5, PAY 3" : "ADD 3, PAY 2";
      this.button.disabled = reduced.matches;
      this.button.setAttribute("aria-pressed", String(this.paused));
      this.button.setAttribute("aria-label", "Quantity offers: ADD 3, PAY 2; ADD 5, PAY 3." + (reduced.matches ? "" : this.paused ? " Resume switching." : " Pause switching."));
    }
    cycle() {
      if (!this.inViewport || this.stopped()) return;
      this.classList.add("is-changing");
      this.pending = setTimeout(() => {
        if (this.isConnected && !document.hidden && this.inViewport && !this.stopped()) this.index = 1 - this.index;
        this.paint();
      }, 140);
    }
  });
  reduced.addEventListener("change", () => badges.forEach(b => b.paint()));
})();
